import {
  RECEIVE_FIELD,
  RECEIVE_PRODUCT_ASSETS,
  RECEIVE_FIELD_PERMISSION,
} from '../constants/actionTypes';
import { getBounds, inverseCoordinates } from '../utils/geo';

const initialState = {
  features: [],
  hasFetched: false,
};

/**
 * Handles redux state for season data
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function fieldReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_FIELD: {
      const coordinates = inverseCoordinates(
        action.payload.boundary.coordinates
      );
      const centroid = [...action.payload.centroid.coordinates].reverse();
      return {
        ...state,
        ...action.payload,
        centroid: {
          coordinates: centroid,
        },
        boundary: {
          coordinates,
          bounds: getBounds(coordinates),
          type: action.payload.boundary.type,
        },
        hasFetched: true,
      };
    }
    case RECEIVE_PRODUCT_ASSETS:
      return {
        ...state,
        features: action.payload.featuresByFields[0].features,
      };
    case RECEIVE_FIELD_PERMISSION:
      return {
        ...state,
        permission: action.permission,
      };
    default:
      return state;
  }
}


export default fieldReducer;
